var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectricalServicesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0951 87.2683C51.8851 88.4083 55.5651 87.6083 57.3151 84.9883C57.5151 84.6883 57.6851 84.3784 57.8351 84.0384H45.8951C46.4851 85.6184 47.6751 86.6983 49.0951 87.2683Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6051 69.1983C45.8651 69.2683 42.6551 69.7484 42.1351 69.9984C40.9151 70.5784 40.9051 72.3084 41.8351 72.8984C41.9651 72.9884 42.1151 73.0484 42.2951 73.0784C42.9251 73.1984 43.8751 73.0784 44.7051 72.9684C45.0251 72.9284 45.3251 72.8884 45.5851 72.8584C50.8051 72.2884 55.9851 71.2084 61.2151 70.6884C61.8051 70.5084 62.3251 70.2184 62.4751 69.6684C62.5151 69.5184 62.5451 69.3584 62.5251 69.1784C57.3651 69.4884 51.7251 68.7683 46.6151 69.1983H46.6051Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8851 67.6283C48.0251 67.2883 54.5851 68.0383 60.6751 67.6183C61.3551 67.5683 62.9551 67.3984 63.4351 66.9684C64.2251 66.2684 64.1451 64.2184 64.3651 63.1084C65.5151 57.6084 70.0951 53.8884 72.7251 49.1684C80.0351 36.0484 73.7651 19.3584 59.5751 14.5384C38.2451 7.27835 19.6651 30.5184 31.3451 49.9984C33.7251 53.9884 37.7451 57.4984 38.9951 62.0884C39.6051 64.3584 38.8551 67.3283 41.8751 67.6283H41.8851ZM59.9251 19.0784C69.2051 23.1484 73.7451 33.6784 70.8351 43.3584C68.6151 50.7684 60.9651 55.3384 60.1651 63.4784L43.3651 63.4984C42.7951 55.6684 35.3351 50.9483 32.9551 43.8983C27.3251 27.2983 43.8651 12.0384 59.9351 19.0684L59.9251 19.0784Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3951 77.2983C41.6451 77.7383 42.0551 77.9084 42.5151 77.9684C42.9551 78.0284 43.4251 77.9784 43.8451 77.9684C49.4751 77.6984 55.5251 75.9584 61.2051 75.5784C61.3151 75.5484 61.4151 75.5183 61.5151 75.4783C63.0451 74.8683 62.7951 72.7883 61.4351 72.4083C61.2751 72.3683 61.1051 72.3384 60.9251 72.3484C56.6651 72.5284 52.0451 73.5483 47.5551 74.2683C45.8551 74.5383 44.1651 74.7784 42.5251 74.8984C41.9051 75.0184 41.4551 75.4084 41.2651 75.8984C41.0951 76.3184 41.1151 76.8183 41.3851 77.2983H41.3951Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3251 79.8083C62.9451 78.8383 62.4151 77.2583 60.9251 77.2383L42.3351 79.7884C42.1551 79.8584 42.0151 79.9483 41.8851 80.0483C41.2151 80.5183 41.0551 81.2284 41.2751 81.8284C41.5451 82.5484 42.3551 83.0983 43.4651 82.8783L61.4051 80.4783C61.8351 80.3583 62.1351 80.1183 62.3251 79.8083Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3451 49.0284C47.9051 49.5984 47.0451 48.1383 46.4951 48.0583L46.1951 57.0383L53.1351 50.2984L51.1851 49.9984L60.7551 36.1184H53.1251L58.9951 23.8084H47.4651L43.5551 41.9883H50.5951L48.3451 49.0284Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0551 85.0784L24.7851 87.3383L27.2851 90.9483C27.9051 91.8483 29.1451 92.0783 30.0451 91.4483C30.9451 90.8283 31.1751 89.5884 30.5451 88.6884L28.0451 85.0784H28.0551Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2751 91.1484L16.0051 93.4083L18.5051 97.0183C19.1251 97.9183 20.3651 98.1483 21.2651 97.5183C22.1651 96.8983 22.3951 95.6584 21.7651 94.7584L19.2651 91.1484H19.2751Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7751 0.248352C23.1851 0.248352 0.745117 22.6884 0.745117 50.2784C0.745117 56.8784 2.03512 63.3184 4.50512 69.3184C4.04512 70.1784 4.06512 71.2583 4.65512 72.1183L6.81512 75.2283C5.54512 77.9983 5.71512 81.3583 7.57512 84.0483L10.8151 88.7283L10.5951 88.8783C9.69512 89.4983 9.46512 90.7384 10.0951 91.6384C10.7151 92.5384 11.9551 92.7684 12.8551 92.1384L13.0751 91.9883L27.7751 81.8184L27.9951 81.6684C28.8951 81.0484 29.1251 79.8083 28.4951 78.9083C27.8751 78.0083 26.6351 77.7783 25.7351 78.4083L25.5151 78.5583L22.2751 73.8783C20.4151 71.1883 17.3351 69.8483 14.2951 70.0583L12.1351 66.9483C11.5551 66.1083 10.5751 65.7084 9.61512 65.8184C7.78512 60.9884 6.77512 55.7483 6.77512 50.2883C6.77512 26.0183 26.5151 6.27835 50.7751 6.27835C75.0351 6.27835 94.7751 26.0184 94.7751 50.2784H94.8051C94.8051 74.5584 75.0551 94.3083 50.7751 94.3083C46.6051 94.3083 42.4851 93.7284 38.5151 92.5784C36.9251 92.1184 35.2551 93.0383 34.7951 94.6283C34.3351 96.2183 35.2551 97.8884 36.8451 98.3484C41.3551 99.6484 46.0351 100.308 50.7751 100.308C78.3651 100.308 100.805 77.8684 100.805 50.2784C100.805 22.6884 78.3651 0.248352 50.7751 0.248352Z",
    fill: "#00FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1683",
    x: -0.0000186563,
    y: -0.0000265539,
    width: 101.55,
    height: 102.38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1683"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1683",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1683"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1683",
    result: "effect3_innerShadow_4857_1683"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricalServicesIcon);
export default __webpack_public_path__ + "static/media/ElectricalServicesIcon.4a7214863e5e122d171e955486d0ebe7.svg";
export { ForwardRef as ReactComponent };